<!--  -->
<template>
  <div>
    <div class="select_box">
      <el-input v-model="query.keywords" style="width:300px;margin-right:10px" placeholder="请输入appid/公众号名称" />
      <el-button type="primary" icon="el-icon-search" @click="serach">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh-right" @click="resetting">重置</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="account_name"
        label="公众号"
        width="180"
        align="center"
      />
      <!-- <el-table-column
        prop="created_at_text"
        label="推送时间"
        width="180"
        align="center"
      /> -->

      <el-table-column prop="created_at_text" label="" align="center">
        <template slot="header">
          推送时间
          <el-tooltip class="item" effect="dark" content="推送时间：系统在30分钟提前准备消息，真正发送时间为策略定时时间点" placement="top">
            <i class="el-icon-question" />
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        prop="total_count"
        label="推送人数"
        width="180"
        align="center"
      />
      <!-- <el-table-column
        prop="sent_count"
        label="成功人数"
        width="180"
        align="center"
      /> -->
      <el-table-column prop="sent_count" label="" align="center">
        <template slot="header">
          成功人数
          <el-tooltip class="item" effect="dark" content="成功人数：到达策略定时时间点后会自动更新，发送成功人数为0可能为公众号被封" placement="top">
            <i class="el-icon-question" />
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="official_timing_record_no"
        label="推送批次"
        width="180"
        align="center"
      />
      <el-table-column
        prop="official_timing_no"
        label="消息编号"
        align="center"
        width="180"
      />
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { pushrecords } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  props: {
    id: {
      type: String,
      default: ''
    }

  },
  data() {
    return {
      tableData: [],
      query: {
        page: 1,
        pageSize: 10,
        strategy_no: null,
        keywords: null
      },
      total: null
    }
  },
  watch: {
    id: {
      handler(newVal) {
        if (newVal) {
          this.query.strategy_no = newVal
          this.gettablelist()
        }
      },
      immediate: true
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async gettablelist() {
      const data = await pushrecords(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.gettablelist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.gettablelist()
    },
    serach() {
      this.query.page = 1
      this.gettablelist()
    },
    resetting() {
      this.query.page = 1
      this.query.keywords = null
      this.gettablelist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.select_box{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>
